import React from 'react';
import styles from '../styles/statusLine.scss';
const StatusLine = ({ text, title, error, icon }) => {
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.line }),
            React.createElement("div", { className: error ? styles.icon_error : styles.icon, title: title }, icon),
            React.createElement("div", { className: styles.time }, text))));
};
export default StatusLine;
